import Quill from "quill";
var URL_REGEX = /(https?:\/\/[^\s]+)/g;
var BULLET_LINE_REGEX = /^\s*[•*-]\s+(.*)$/;
var Delta = Quill.import("delta");
function appendLineWithLinks(delta, text) {
    URL_REGEX.lastIndex = 0;
    var lastIndex = 0;
    var match;
    while ((match = URL_REGEX.exec(text)) !== null) {
        if (match.index > lastIndex) {
            delta.insert(text.slice(lastIndex, match.index));
        }
        delta.insert(match[0], { link: match[0] });
        lastIndex = match.index + match[0].length;
    }
    if (lastIndex < text.length) {
        delta.insert(text.slice(lastIndex));
    }
}
export function buildPlainTextDelta(text) {
    var lines = text.replace(/\r\n/g, "\n").split("\n");
    var delta = new Delta();
    lines.forEach(function (line) {
        var bulletMatch = line.match(BULLET_LINE_REGEX);
        var content = bulletMatch ? bulletMatch[1] : line;
        if (content.trim() === "") {
            delta.insert("\n");
            return;
        }
        appendLineWithLinks(delta, content);
        delta.insert("\n", bulletMatch ? { list: "bullet" } : undefined);
    });
    return delta;
}
export function insertFormattedPlainText(editor, text, atIndex, source) {
    var _a;
    if (source === void 0) { source = "user"; }
    var selection = atIndex !== undefined
        ? { index: atIndex, length: 0 }
        : ((_a = editor.getSelection(true)) !== null && _a !== void 0 ? _a : { index: editor.getLength() - 1, length: 0 });
    var insertDelta = buildPlainTextDelta(text);
    var changeDelta = new Delta()
        .retain(selection.index)
        .delete(selection.length)
        .concat(insertDelta);
    editor.updateContents(changeDelta, source);
    var insertedLength = insertDelta.length();
    editor.setSelection(selection.index + insertedLength, 0, "silent");
    return insertedLength;
}
export function createPlainTextClipboardMatcher(isPlainTextPasteRef) {
    return function (node, delta) {
        var _a;
        if (!isPlainTextPasteRef.current) {
            return delta;
        }
        var text = (_a = node.data) !== null && _a !== void 0 ? _a : "";
        if (text.trim() === "") {
            return delta;
        }
        return buildPlainTextDelta(text);
    };
}
